module.exports = __webpack_public_path__ + "img/rugby-category-icon-white.0856afbe.png";